import React from 'react';
import {View, StyleSheet} from 'react-native';
import flexCheck from '../../../../utils/flexCheck';

const Views = React.forwardRef((props, ref) => {
  const styles = StyleSheet.flatten(props.style);
  let updatedStyles = false;
  if (typeof props !== 'undefined' && typeof styles !== 'undefined') {
    updatedStyles = flexCheck(styles);
  }
  return (
    <>
      <View
        ref={ref}
        {...props}
        style={updatedStyles ? updatedStyles : styles}
      />
    </>
  );
});
export default Views;
